module.exports = __webpack_public_path__ + "img/keypad-third.6e7ad99f.svg";